const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class EconomicProgress extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.EconomicProgress,
            "Each player produces immediately: Evaluate corruption. Produce food. Evaluate consumption. Produce resource.",
            {}
        )
    }
}

module.exports = EconomicProgress;